import { NotFoundPage } from '@/components/pages/WorkspaceStatusPage';

/** Catch-all for unmatched workspace routes — keeps sidebar and header visible. */
export function WorkspaceNotFoundHandler() {
  return <NotFoundPage />;
}
